'use client';

import type { CmsApiPage } from '#/modules/cms/api/types/CmsApiDocument';
import { useReloadIfFreeCodeBlockAndClientNavigation } from '#/modules/cms/hooks/useReloadIfFreeCodeBlockAndClientNavigation';
import { DynamicNotFoundPage } from '#/pages/NotFound/DynamicNotFoundPage';

import { CmsPageBody } from './CmsPageBody';
import { CmsPageLayout } from './CmsPageLayout';

type Props = {
  content: CmsApiPage;
};

export function CmsPagePage({ content }: Props) {
  const { showPageNotFound } =
    useReloadIfFreeCodeBlockAndClientNavigation(content);
  if (showPageNotFound) return <DynamicNotFoundPage />;

  return (
    <CmsPageLayout content={content}>
      <CmsPageBody content={content} />
    </CmsPageLayout>
  );
}
